import React from 'react';

import Tag from '@atlaskit/tag';

import { Utils } from '@qality/common-utils';

import './_more-filters-tag-list.scss';

export type TagData = {
  filterLabel: string;
  filterName: string;
  isEnabled: boolean;
};

export type Tags = Array<TagData>;

export type Props = {
  onTagRemove: (filterValues: Array<{ name: string; value: boolean }>) => void;
  tags: Tags;
};

const MoreFiltersTagList: React.FC<Props> = ({ onTagRemove, tags }: Props) => {
  const handleOnRemove = (filterName: string) => {
    onTagRemove([{ name: filterName, value: false }]);
  };

  const renderTags = () => {
    return tags.map((tag) => {
      if (!tag.isEnabled) {
        return null;
      }

      return (
        <Tag
          key={tag.filterName}
          text={tag.filterLabel}
          removeButtonLabel='Remove'
          onAfterRemoveAction={() => handleOnRemove(tag.filterName)}
        />
      );
    });
  };

  return (
    <>
      {Utils.isNilOrEmpty(tags) ? null : (
        <span className='tags-wrapper'>{renderTags()}</span>
      )}
    </>
  );
};

export default MoreFiltersTagList;
